import qs from 'qs';
import * as _ from 'lodash';
import { get } from '../api';
import type { AuditLog } from '../../types';
import type { TopicActionSelectOption, UserSelectOption } from './store';

export const LOAD_AUDIT_LOGS_TASK = 'LOAD_AUDIT_LOGS_TASK';
export const LOAD_AUDIT_LOGS_COUNT_TASK = 'LOAD_AUDIT_LOGS_COUNT_TASK';
export const LOAD_AUDIT_LOG_TOPIC_ACTION_OPTIONS = 'LOAD_AUDIT_LOG_TOPIC_ACTION_OPTIONS';
export const LOAD_AUDIT_LOG_USER_OPTIONS = 'LOAD_AUDIT_LOG_USER_OPTIONS';
export const CREATE_AUDIT_LOG_EXPORT = 'CREATE_AUDIT_LOG_EXPORT';

export type LoadAuditLogsParams = {
  topics?: string[];
  actions?: string[];
  topicActions?: string[];
  sortBy?: string;
  sortDir?: string;
  offset?: number;
  limit?: number;
};

const AuditLogActions = {
  loadAuditLogs: (logQuery: LoadAuditLogsParams) => ({
    type: LOAD_AUDIT_LOGS_TASK,
    meta: { logQuery },
    payload: async () => get<AuditLog[]>(`/api/audit_logs?${qs.stringify(logQuery, { arrayFormat: 'comma' })}`),
  }),
  loadAuditLogCount: (logQuery: LoadAuditLogsParams) => {
    // For a count, we want to know how many records would be returned without pagination:
    const queryParams = _.omit(logQuery, 'page', 'pageSize', 'offset', 'limit');
    return ({
      type: LOAD_AUDIT_LOGS_COUNT_TASK,
      meta: { logQuery },
      payload: async () => get<number>(`/api/count/audit_logs?${qs.stringify(queryParams, { arrayFormat: 'comma' })}`),
    });
  },
  loadAuditLogTopicActionOptions: () => ({
    type: LOAD_AUDIT_LOG_TOPIC_ACTION_OPTIONS,
    payload: async () => get<{ topicsAndActions: TopicActionSelectOption[] }>('/api/filters/audit_logs/topic_actions'),
  }),
  loadAuditLogUserFilterOptions: () => ({
    type: LOAD_AUDIT_LOG_USER_OPTIONS,
    payload: async () => get<UserSelectOption[]>('/api/filters/audit_logs/acting_users'),
  }),
};

export default AuditLogActions;
